import React from 'react';
import PropTypes from 'prop-types';

import {
  Container,
  Desc,
  Separator,
  Title,
} from './common/styles';
import OptionsControl from './options-control';
import { updateNotifyOnFollow } from '../../../services/profiles/notification-settings-service';

export default function FollowOptionsControl(props) {
  return (
    <Container>
      <Title>Livewire Wrap Up Emails</Title>
      <Desc>
        A personalised email with wires published by Contributors you follow
        or contain Funds and Listed Products you follow. How frequently would
        you like to receive your Wrap Up emails?
      </Desc>
      <OptionsControl
        id="follow-options"
        options={props.options}
        frequenciesToUpdate={props.frequenciesToUpdate}
        updateOptionsFunction={updateNotifyOnFollow}
      />
      <Separator />
    </Container>
  );
}

FollowOptionsControl.propTypes = {
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  frequenciesToUpdate: PropTypes.arrayOf(PropTypes.string),
};

FollowOptionsControl.defaultProps = {
  frequenciesToUpdate: null,
};
